import { render, staticRenderFns } from "./WorkflowRunButton.vue?vue&type=template&id=63954684"
import script from "./WorkflowRunButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowRunButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports